import { ROUTE_PATH } from "@/common/constants/routing";
import {
  AppPermission,
  DamageDetectionAggregateDto,
  DamageDetectionAggregateItemDto,
  DamageDetectionAggregateItemReferenceDto,
  DamageDetectionAggregateReferenceDto,
} from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import DamageDetectionAggregateInline, {
  DamageDetectionAggregateInlineProps,
} from "./DamageDetectionAggregateInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: DamageDetectionAggregateDto | DamageDetectionAggregateReferenceDto | null | undefined;
  entityId?: string | null;
  item?: DamageDetectionAggregateItemDto | DamageDetectionAggregateItemReferenceDto;
  itemId?: string | null;
  inlineProps?: Partial<DamageDetectionAggregateInlineProps>;
}

export default function DamageDetectionAggregateLink({
  entity,
  entityId,
  item,
  itemId,
  inlineProps,
  ...otherProps
}: Props) {
  if (!entity && !entityId) {
    return null;
  }

  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.DamageDetectionRead]}
      to={ROUTE_PATH.DAMAGE_DETECTION_AGGREGATE_VIEW(entity?.id || entityId || "")}
      content={
        <DamageDetectionAggregateInline
          entity={entity}
          entityId={entityId}
          item={item}
          itemId={itemId}
          {...inlineProps}
        />
      }
      {...otherProps}
    />
  );
}
